import React, { useLayoutEffect, useRef } from 'react';
import FloatingScrollArea from '../../common/FloatingScrollArea';

// 같은 브라우저 탭에서 화면을 오갈 때만 보관한다. 조회 조건은 URL이 담당한다.
const positions = new Map();

export default function ScrollRegion({ scrollKey, children, compact = false, preservePositionOnChange = false }) {
  const outer = useRef(null);
  const content = useRef(null);
  const restoring = useRef(false);
  const mounted = useRef(false);
  useLayoutEffect(() => {
    const el = outer.current;
    // 현황 화면 안에서 필터만 바꾸면 보던 위치를 유지한다. 상세 화면에서 돌아올 때는 저장 위치를 복원한다.
    const wanted = preservePositionOnChange && mounted.current ? el.scrollTop : positions.get(scrollKey) || 0;
    mounted.current = true;
    restoring.current = wanted > 0;
    if (!wanted) el.scrollTop = 0;
    const restore = () => {
      if (!restoring.current) return;
      el.scrollTop = wanted;
    };
    // 상자별 응답이 차례로 도착하므로 한 번 맞았어도 본문 높이가 다시 변할 수 있다.
    // 사용자가 직접 조작할 때까지 같은 위치를 복원한다.
    const stop = () => { restoring.current = false; };
    restore();
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(restore) : null;
    observer?.observe(content.current);
    el.addEventListener('wheel', stop, { passive: true });
    el.addEventListener('touchstart', stop, { passive: true });
    el.addEventListener('keydown', stop);
    // 플로팅 막대는 viewport의 형제다. 막대를 잡아도 자동 복원을 끝낸다.
    const host = el.parentElement;
    host.addEventListener('pointerdown', stop, true);
    return () => {
      if (!restoring.current) positions.set(scrollKey, el.scrollTop);
      observer?.disconnect();
      el.removeEventListener('wheel', stop);
      el.removeEventListener('touchstart', stop);
      el.removeEventListener('keydown', stop);
      host.removeEventListener('pointerdown', stop, true);
    };
  }, [scrollKey, preservePositionOnChange]);
  return (
    <FloatingScrollArea ref={outer} className="flex-1" axis="y" aria-label="통계 본문" onScroll={() => {
      if (!restoring.current) {
        positions.set(scrollKey, outer.current.scrollTop);
        if (positions.size > 60) positions.delete(positions.keys().next().value);
      }
    }}>
      <div ref={content} className={compact ? 'space-y-2 p-2' : 'space-y-3 p-4'}>{children}</div>
    </FloatingScrollArea>
  );
}
